import { createSvgIcon } from '@mui/material';

export const MasterCardIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0Dd)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#FFEFE5'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M29.303 11.2509H23.8179V21.1077H29.303V11.2509Z'
        fill='#FF5F00'
      />
      <path
        d='M24.1662 16.1793C24.1654 15.23 24.3805 14.293 24.7953 13.4391C25.2101 12.5853 25.8137 11.837 26.5605 11.2509C25.6357 10.524 24.5251 10.072 23.3556 9.94645C22.1861 9.82092 21.0048 10.027 19.9469 10.541C18.889 11.0551 17.997 11.8565 17.3729 12.8535C16.7489 13.8506 16.418 15.0031 16.418 16.1793C16.418 17.3555 16.7489 18.508 17.3729 19.5051C17.997 20.5021 18.889 21.3035 19.9469 21.8176C21.0048 22.3316 22.1861 22.5377 23.3556 22.4122C24.5251 22.2866 25.6357 21.8346 26.5605 21.1077C25.8137 20.5216 25.2101 19.7733 24.7953 18.9195C24.3805 18.0656 24.1654 17.1286 24.1662 16.1793Z'
        fill='#EB001B'
      />
      <path
        d='M36.7027 16.1793C36.7027 17.3555 36.3718 18.508 35.7478 19.5051C35.1238 20.5021 34.2319 21.3035 33.1739 21.8175C32.116 22.3316 30.9348 22.5377 29.7653 22.4122C28.5958 22.2866 27.4852 21.8346 26.5605 21.1077C27.3066 20.521 27.9097 19.7726 28.3245 18.9189C28.7392 18.0652 28.9547 17.1284 28.9547 16.1793C28.9547 15.2302 28.7392 14.2934 28.3245 13.4397C27.9097 12.586 27.3066 11.8376 26.5605 11.2509C27.4852 10.524 28.5958 10.072 29.7653 9.94644C30.9348 9.82092 32.116 10.027 33.1739 10.5411C34.2319 11.0551 35.1238 11.8565 35.7478 12.8535C36.3718 13.8506 36.7027 15.0031 36.7027 16.1793Z'
        fill='#F79E1B'
      />
      <path
        d='M36.1046 20.0637V19.8619H36.186V19.8208H35.9787V19.8619H36.0602V20.0637H36.1046ZM36.5069 20.0637V19.8204H36.4434L36.3703 19.9878L36.2973 19.8204H36.2337V20.0637H36.2786V19.8802L36.3471 20.0384H36.3936L36.4621 19.8798V20.0637H36.5069Z'
        fill='#F79E1B'
      />
    </g>
    <defs>
      <filter
        id='filter0Dd'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1DropShadow'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1DropShadow'
          result='effect2DropShadow'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2DropShadow'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'MasterCardIcon',
);
